import { render } from "./payment_step.vue?vue&type=template&id=21f6bcf6"
import script from "./payment_step.vue?vue&type=script&lang=js"
export * from "./payment_step.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__